/**
 * fetch data
 * 可用 axios 代替
 */

import 'whatwg-fetch';
import interceptor from './interceptor';
import localDb from './localDb';

class Http {
  get = (url, params) => {
    // GET请求
    url = params ? this.build(url, params) : url;
    return this.request(url, {
      method: 'GET',
    });
  };

  post = (url, body) => {
    // POST请求
    const options = {
      method: 'POST',
    };
    if (body) options.body = JSON.stringify(body);
    return this.request(url, options);
  };

  html = (url, params) => {
    url = params ? this.build(url, params) : url;
    return this.requestHtml(url, {
      method: 'GET',
    });
  };

  download = (url, params, filename) => {
    url = params ? this.build(url, params) : url;
    return this.requestBlod(
      url,
      {
        method: 'GET',
      },
      filename,
    );
  };

  request = (url, options) => {
    // 根请求
    options.headers = this.defaultHeader();
    options.credentials = 'include';
    return (
      fetch(url, options)
        // .then(this.checkStatus)
        .then(interceptor)
        .then(response => response.json())
    );
    // .catch(err => browserHistory.replace(`/login`))
  };

  requestHtml = (url, options) => {
    // 根请求
    options.headers = this.defaultHeader();
    options.credentials = 'include';
    fetch(url, options)
      // .then(this.checkStatus)
      .then(interceptor)
      .then(response => response.text())
      .then(html => {
        const win = window.open('about:blank', '_blank');
        win.document.open();
        win.document.write(html);
        win.document.close();
      });

    // .catch(err => browserHistory.replace(`/login`))
  };

  requestBlod = (url, options, filename) => {
    // 根请求
    options.headers = this.defaultHeader();
    options.credentials = 'include';
    fetch(url, options)
      // .then(this.checkStatus)
      .then(interceptor)
      .then(response => response.blob())
      .then(blob => {
        console.log('blob:', blob);
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, filename); // 兼容ie10
        } else {
          const a = document.createElement('a');
          document.body.appendChild(a); // 兼容火狐，将a标签添加到body当中
          // 获取 blob 本地文件连接 (blob 为纯二进制对象，不能够直接保存到磁盘上)
          a.href = window.URL.createObjectURL(blob);
          a.download = filename;
          a.target = '_blank'; // a标签增加target属性
          a.click();
          a.remove(); // 移除a标签
          window.URL.revokeObjectURL(window.URL.createObjectURL(blob));
        }
      });

    // .catch(err => browserHistory.replace(`/login`))
  };

  checkStatus = response => {
    if (response.status >= 200 && response.status < 300) {
      return response;
    }

    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  };

  defaultHeader = () => {
    // 默认头
    return {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `${localDb.get('token')}`,
    };
  };

  build = (url, params) => {
    // URL构建方法
    const ps = [];
    if (params) {
      Object.keys(params).forEach(p => {
        if (p) {
          ps.push(`${p}=${encodeURIComponent(params[p])}`);
        }
      });
    }
    return url + (url.indexOf('?') === -1 ? '?' : '&') + ps.join('&');
  };
}

export default new Http();



// WEBPACK FOOTER //
// ./src/util/http.js